<template>
    <div class="examine-notice-detail">
        <div class="examin-notice-box">
            <div class="widthPC-90 margin-x-auto">
                <div class="fileNo text-right" v-if="baseInfo.fileNo">{{ baseInfo.fileNo }}</div>
                <div class="related-title">项目基础信息</div>
                <table class="detail-table" border="1" cellspacing="0" cellpadding="0">
                    <tr>
                        <th colspan="4" class="py-2">{{ baseInfo.title }}</th>
                    </tr>
                    <tr>
                        <td class="font-bold">项目名称 ：</td>
                        <td>{{ baseInfo.projectName }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">项目编码 ：</td>
                        <td>{{ baseInfo.projectCode }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">项目业主名称 ：</td>
                        <td>{{ baseInfo.purchaserName || '-' }}</td>
                    </tr>
                    <!-- <tr>
                        <td class="font-bold">业主单位咨询电话 ：</td>
                        <td>{{ contactNotices.consultPhone || '-' }}</td>
                    </tr> -->
                    <tr>
                        <td class="font-bold">中选中介机构名称 ：</td>
                        <td>{{ baseInfo.bidAgentName || '-' }}</td>
                    </tr>
                    <!-- <tr>
                        <td class="font-bold">中介机构联系地址 ：</td>
                        <td>{{ notice.bidAgentOfficeAddress || '-' }}</td>
                    </tr> -->
                    <tr>
                        <td class="font-bold">服务内容 ：</td>
                        <td>{{ baseInfo.serviceContent || '-' }}</td>
                    </tr>
                    <!-- <tr>
                        <td class="font-bold">项目规模 ：</td>
                        <td>{{ baseInfo.restrictions || '-' }}</td>
                    </tr> -->
                    <!-- <tr>
                        <td class="font-bold">服务金额 ：</td>
                        <td>
                            <span v-if="baseInfo.minServicePrice>0 || baseInfo.minServicePrice>0">{{ baseInfo.minServicePrice +' 至 ' + baseInfo.maxServicePrice || '-' }}</span>
                            <span v-else>-</span>
                        </td>
                    </tr> -->
                    <tr>
                        <td class="font-bold">合同金额 ：</td>
                        <td>{{ baseInfo.contractPrice || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">合同时间 ：</td>
                        <td>{{ baseInfo.contractDate || '-' }}</td>
                    </tr>
                    <!-- <tr>
                        <td class="font-bold">服务终止时间 ：</td>
                        <td>{{ baseInfo.terminationDate || '-' }}</td>
                    </tr> -->

                </table>
                
                <ad :type="1"></ad>

                <div>
                    <div class="related-title">项目业务流程</div>
                    <div class="process"> 
                            <div class="process-title" 
                                @click="handleProcessClick(list)" 
                                v-for="list in processList" 
                                :class="list.value == processValue ? 'active' : ''" 
                                :style="list.id?'':'backgroundColor:#fff;color:rgb(204 204 204);cursor:not-allowed;'"
                                :key="list.value">
                                 {{ list.label }}
                            </div> 
                    </div>
                    <div>
                        <table class="detail-table related-table" border="1" cellspacing="0" cellpadding="0" v-show="tenderingBiddings && tenderingBiddings.id && processValue == 1">
                            <tr>
                                <th>采购项目编码</th>
                                <td colspan="3">{{ tenderingBiddings.projectCode }}</td>
                            </tr>
                            <tr>
                                <th>采购项目名称</th>
                                <td colspan="3">{{ tenderingBiddings.projectName }}</td>
                            </tr>
                            <!-- <tr>
                                <th>项目业主名称</th>
                                <td colspan="3">{{ tenderingBiddings.serviceSubjectName }}</td>
                            </tr> -->
                        </table>
                        <table class="detail-table related-table" border="1" cellspacing="0" cellpadding="0" v-show="openingRecords && openingRecords.id  && processValue == 2">
                            <tr>
                                <th>项目编码</th>
                                <td colspan="3">{{ openingRecords.projectCode }}</td>
                            </tr>
                            <tr>
                                <th>标题</th>
                                <td colspan="3">{{ openingRecords.title }}</td>
                            </tr>
                            <tr>
                                <th>发布时间</th>
                                <td colspan="3">{{ openingRecords.publishDate }}</td>
                            </tr>
                            <tr>
                                <th>项目类型</th>
                                <td colspan="3">{{ openingRecords.projectTypeName }}</td>
                            </tr>
                            <!-- <tr>
                                <th>城市</th>
                                <td>{{ openingRecords.servicePrice }}</td>
                            </tr> -->
                            <tr>
                                <th>招标项目名称</th>
                                <td>{{ openingRecords.tenderProjectName }}</td>
                            </tr>
                            <tr>
                                <th>标段(包)名称</th>
                                <td>{{ openingRecords.bidSectionName || '-'}}</td>
                            </tr>
                            <tr>
                                <th>开标时间</th>
                                <td>{{ openingRecords.bidOpeningTime || '-'}}</td>
                            </tr>
                            <tr>
                                <th>开标地点</th>
                                <td>{{ openingRecords.bidOpeningAddress }}</td>
                            </tr>
                            <!-- <tr>
                                <th>公告内容</th>
                                <td>{{ openingRecords.bidAgentName }}</td>
                            </tr> -->
                            <tr>
                                <th>开标信息</th>
                                <td>{{ openingRecords.bidtext }}</td>
                            </tr>
                        </table>
                        <table class="detail-table related-table" border="1" cellspacing="0" cellpadding="0" v-show="awardCandidates && awardCandidates.id && processValue == 3">
                            <tr>
                                <th>项目编码</th>
                                <td colspan="3">{{ awardCandidates.projectCode }}</td>
                            </tr>
                            <tr>
                                <th>标题</th>
                                <td colspan="3">{{ awardCandidates.title }}</td>
                            </tr>
                            <tr>
                                <th>发布时间</th>
                                <td colspan="3">{{ awardCandidates.publishDate }}</td>
                            </tr>
                            <tr>
                                <th>项目类型</th>
                                <td colspan="3">{{ awardCandidates.projectTypeName }}</td>
                            </tr>
                            <!-- <tr>
                                <th>城市</th>
                                <td>{{ awardCandidates.servicePrice }}</td>
                            </tr> -->
                            <tr>
                                <th>招标项目名称</th>
                                <td>{{ awardCandidates.tenderProjectName }}</td>
                            </tr>
                            <tr>
                                <th>标段(包)名称</th>
                                <td>{{ awardCandidates.bidSectionName || '-'}}</td>
                            </tr>
                            <tr>
                                <th>公示标题</th>
                                <td>{{ awardCandidates.publicityName || '-'}}</td>
                            </tr>
                            <tr>
                                <th>公示类型</th>
                                <td>{{ awardCandidates.publicityType }}</td>
                            </tr>
                            <tr>
                                <th>公示开始时间</th>
                                <td>{{ awardCandidates.publicityStartTime }}</td>
                            </tr>
                            <tr>
                                <th>公示结束时间</th>
                                <td>{{ awardCandidates.publicityEndTime }}</td>
                            </tr>
                            <tr>
                                <th>公示发布时间</th>
                                <td>{{ awardCandidates.publicityReferTime }}</td>
                            </tr>
                             <tr>
                                <th>公告内容</th>
                                <td>{{ awardCandidates.richText }}</td>
                            </tr>
                            

                        </table>
                        <table class="detail-table related-table" border="1" cellspacing="0" cellpadding="0" v-show="awardAnnouncements && awardAnnouncements.id  && processValue == 4">
                             <tr>
                                <th>项目编码</th>
                                <td colspan="3">{{ awardAnnouncements.projectCode }}</td>
                            </tr>
                            <tr>
                                <th>标题</th>
                                <td colspan="3">{{ awardAnnouncements.title }}</td>
                            </tr>
                            <tr>
                                <th>发布时间</th>
                                <td colspan="3">{{ awardAnnouncements.publishDate }}</td>
                            </tr>
                            <tr>
                                <th>项目类型</th>
                                <td colspan="3">{{ awardAnnouncements.projectTypeName }}</td>
                            </tr>
                            <!-- <tr>
                                <th>城市</th>
                                <td>{{ awardAnnouncements.servicePrice }}</td>
                            </tr> -->
                            <tr>
                                <th>招标项目名称</th>
                                <td>{{ awardAnnouncements.tenderProjectName }}</td>
                            </tr>
                            <tr>
                                <th>标段(包)名称</th>
                                <td>{{ awardAnnouncements.bidSectionName || '-'}}</td>
                            </tr>
                            <tr>
                                <th>相关统一交易识别码</th>
                                <td>{{ awardAnnouncements.unifiedDealCodes || '-'}}</td>
                            </tr>
                            <tr>
                                <th>公告性质</th>
                                <td>{{ awardAnnouncements.noticeNature }}</td>
                            </tr>
                            <tr>
                                <th>公告内容</th>
                                <td>{{ awardAnnouncements.richtext }}</td>
                            </tr>
                            
                        </table>
                        <table class="detail-table related-table" border="1" cellspacing="0" cellpadding="0" v-show="awardResults && awardResults.id  && processValue == 5">
                             <tr>
                                <th>项目编码</th>
                                <td colspan="3">{{ awardResults.projectCode }}</td>
                            </tr>
                            <tr>
                                <th>标题</th>
                                <td colspan="3">{{ awardResults.title }}</td>
                            </tr>
                            <tr>
                                <th>发布时间</th>
                                <td colspan="3">{{ awardResults.publishDate }}</td>
                            </tr>
                            <tr>
                                <th>项目类型</th>
                                <td colspan="3">{{ awardResults.projectTypeName }}</td>
                            </tr>
                            <!-- <tr>
                                <th>城市</th>
                                <td>{{ awardResults.servicePrice }}</td>
                            </tr> -->
                            <tr>
                                <th>招标项目名称</th>
                                <td>{{ awardResults.tenderProjectName }}</td>
                            </tr>
                            <tr>
                                <th>标段(包)名称</th>
                                <td>{{ awardResults.bidSectionName || '-'}}</td>
                            </tr>
                            <tr>
                                <th>中标人名称</th>
                                <td>{{ awardResults.winBidderName || '-'}}</td>
                            </tr>
                            <tr>
                                <th>估算交易总金额</th>
                                <td>{{ awardResults.tradeAmount  || '-'}}</td>
                            </tr>
                            <tr>
                                <th>价款形式代码</th>
                                <td>{{ awardResults.bidCurrency || '-' }}</td>
                            </tr>
                            <tr>
                                <th>中标金额</th>
                                <td>{{ awardResults.bidAmount   || '-'}}</td>
                            </tr>
                            <tr>
                                <th>价格币种代码</th>
                                <td>{{ awardResults.bidCurrency || '-' }}</td>
                            </tr>
                            <tr>
                                <th>价格单位</th>
                                <td>{{ awardResults.priceUnit }}</td>
                            </tr>
                            <!-- <tr>
                                <th>其他形式报价结果</th>
                                <td>{{ awardResults.richtext }}</td>
                            </tr> -->
                            <tr>
                                <th>公告性质</th>
                                <td>{{ awardResults.noticeNature }}</td>
                            </tr>
                            <tr>
                                <th>公告内容</th>
                                <td>{{ awardResults.richText }}</td>
                            </tr>
                        </table>
                        <table class="detail-table related-table" border="1" cellspacing="0" cellpadding="0" v-show="contactNotices && contactNotices.id  && processValue == 6">
                             <tr>
                                <th>项目编码</th>
                                <td colspan="3">{{ awardResults.projectCode }}</td>
                            </tr>
                            <tr>
                                <th>标题</th>
                                <td colspan="3">{{ awardResults.title }}</td>
                            </tr>
                            <tr>
                                <th>发布时间</th>
                                <td colspan="3">{{ awardResults.publishDate }}</td>
                            </tr>
                            <tr>
                                <th>项目类型</th>
                                <td colspan="3">{{ awardResults.projectTypeName }}</td>
                            </tr>
                            <!-- <tr>
                                <th>城市</th>
                                <td>{{ awardResults.servicePrice }}</td>
                            </tr> -->
                            <tr>
                                <th>招标项目名称</th>
                                <td>{{ awardResults.tenderProjectName }}</td>
                            </tr>
                            <tr>
                                <th>标段(包)名称</th>
                                <td>{{ awardResults.bidSectionName || '-'}}</td>
                            </tr>
                            <tr>
                                <th>合同名称</th>
                                <td>{{ awardResults.contractName || '-'}}</td>
                            </tr>
                            <tr>
                                <th>合同金额</th>
                                <td>{{ awardResults.contractPrice }}</td>
                            </tr>
                            <tr>
                                <th>签订时间</th>
                                <td>{{ awardResults.contractSignTime }}</td>
                            </tr>
                             <tr>
                                <th>合同内容</th>
                                <td>
                                    <!-- {{ awardResults.richText }} -->

                                    <vue-markdown :source="awardResults.richText"></vue-markdown>
                                </td>
                            </tr>
                            

                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueMarkdown from 'vue-markdown'
export default {
    components: {
        VueMarkdown
    },
    data() {
        return {
            id: this.$route.query.id || null,
            baseInfo: {},
            processList: [
                { label: '招标公示', value: 1,type:'tenderingBiddings',id:null },
                { label: '开标记录', value: 2,type:'openingRecords',id:null },
                { label: '中标候选人', value: 3,type:'awardCandidates',id:null },
                { label: '中标公示', value: 4,type:'awardAnnouncements',id:null },
                { label: '中标结果', value: 5,type:'awardResults',id:null },
                { label: '合同公示', value: 6,type:'contactNotices',id:null },
            ],
            processValue: 1,
            awardAnnouncements:{},
            awardCandidates:{},
            awardResults:{},
            contactNotices:{},
            openingRecords:{},
            tenderingBiddings:{},
        }
    },
    created() {

    },
    mounted() {
        this.getData();
    },
    methods: {
        handleProcessClick(item) {
            if (!item.id) {
                // this.$message.warning('暂无数据');
                return;
            }
            this.processValue = item.value;
        },
        getData() {
            let ajaxUrl = this.$api.common.agencyService.DetailGD() + '?id=' + this.id;
            this.$axios.get(ajaxUrl).then((res) => {
                console.log('数据详情', res);
                this.baseInfo = res.data.baseInfo || {};
                this.awardAnnouncements = (res.data.awardAnnouncements && res.data.awardAnnouncements[0]) || {}; //中标公告
                this.awardCandidates = (res.data.awardCandidates && res.data.awardCandidates[0]) || {}; //中标候选人
                this.awardResults = (res.data.awardResults && res.data.awardResults[0]) || {}; //中标结果
                this.contactNotices = (res.data.contactNotices && res.data.contactNotices[0])  || {}; //合同公示
                this.openingRecords =  (res.data.openingRecords && res.data.openingRecords[0])  || {}; //开标记录
                this.tenderingBiddings = (res.data.tenderingBiddings && res.data.tenderingBiddings[0])  || {}; //招标公示
                
                 // ★ 核心代码：将对应对象的 id 传入 processList
            this.processList.forEach(item => {
                // this[item.type] 相当于 this.tenderingBiddings, this.openingRecords 等
                const targetData = this[item.type]; 
                // 如果有数据且有 id 就赋值，否则给 null
                item.id = (targetData && targetData.id) ? targetData.id : null;
            });
            console.log('processList', this.processList);
            }).catch((err) => { });

        }
    }
}
</script>

<style lang="less" scoped> 

.detail-table.related-table{
    th,td{
        padding: 25px  10px;
    }
    th{
        background: #f1f8ff;
        width: 150px;
        min-width: 80px;
    }
    td{
        min-width: 220px;
        border: 1px solid #d6d6d6;
    }
}
.process {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #e6e6e6;
    border-radius: 5px;
    box-shadow: 0 2px 4px #ebf1f5;
    .process-title {
        width: calc(100%/5);
        font-size: 16px;
        color: #333;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-right: 1px solid #fff;
        font-weight: bold;
        &:hover,
        &.active {
            cursor: pointer;
            background-color: #2c5282;
            color: #ffffff;
        }
    }
} 

.examin-notice-box {
    padding: 20px;
    width: 100%;
    background: #fff;
}

.fileNo {
    font-size: 20px;
    color: #666;
}

.detail-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;

    th {
        background: #f1f8ff;
        text-align: center;
    }

    th,
    td {
        padding: 15px 10px;
        border: 1px solid #eee;
        min-width: 150px;
    }
}

.detail-content {
    margin-top: 20px;
    padding: 10px;
    line-height: 3;
    border: 1px solid #ebf1f5;
    box-shadow: 0 2px 4px #ebf1f5;
}
</style>